<ng-container>
  <div
    data-test="HMavLxlA"
    class="schedule-scale-track scrollbar-thin scrollbar-horizontal"
    data-simplebar
  >
    <div data-test="8ZKVwxp7" class="schedule-scale">
      <div data-test="_6OlIWUR" class="schedule-scale__days d-block text-nowrap">
        <div
          data-test="wEALs3cd"
          class="schedule-scale__day d-inline-block align-top"
          *ngFor="let item of items; let i = index; last as isLast"
          [class.begin]="i === 0"
          [style.color]="item.color"
          [style.width.%]="item.durationPercent"
        >
          <div data-test="OCUEoyEC" class="d-flex">
            <div data-test="giJlCp_w">
              <div data-test="LG3gHxVC" class="hours text-small">
                {{ item.startTime | time: 'HH:mm' }}
              </div>
            </div>
            <div data-test="xLWMKmTD" class="mr-3 ml-auto" *ngIf="isLast">
              <div data-test="Tjdljfvw" class="hours text-small">
                {{ item.endTime | time: 'HH:mm' }}
              </div>
            </div>
          </div>
          <div data-test="PExLcWdD" class="schedule-scale__day-progress">
            <div data-test="jiQekER_" class="line"></div>
          </div>
          <div data-test="T0SX7o57" class="schedule-scale__day-info">
            <div data-test="1vNgdpx2" class="assignment">
              {{ item.name }}
            </div>
            <div data-test="EDK60ggf" class="type text-light text-small">
              {{ item.label }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
